var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleQuotes = function SvgDoubleQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M369.5,91.2C183.9,175.2,10,375.2,10,633.4c0,159.5,101.5,275.5,226.1,275.5c130.5,0,197.2-98.6,197.2-188.5c0-104.3-72.5-185.6-179.8-185.6c-31.9,0-63.8,8.7-81.2,23.2c0-127.6,101.4-278.4,258-356.6L369.5,91.2z M926.2,91.2c-185.6,84-362.4,284.1-362.4,542.2c0,159.5,104.4,275.5,229,275.5c130.5,0,197.2-98.6,197.2-188.5c0-104.3-72.5-185.6-182.7-185.6c-31.9,0-60.9,8.7-78.3,23.2c0-127.6,101.5-278.4,258-356.6L926.2,91.2z"
  }))));
};
export default SvgDoubleQuotes;